import { useMemo } from 'react';

import { Plan } from '@/api';
import { getPlansAvailability } from '@/config';
import { sortPlansByCategory } from '@/helpers';
import { useAppSelector } from '@/redux/hooks';
import {
  paymentSelectors,
  profileSelectors,
  userSelectors,
} from '@/redux/selectors';

// Plans the account can buy from the header: those of its own category (the
// first available one for its mode). Empty while the plans or the profile are
// still loading, and when the category has no plans (e.g. locked Pro plans).
// Derived during render, so the list never lags the plans by a render.
const useOwnPlans = (): Plan[] => {
  const plans = useAppSelector(paymentSelectors.getPaymentPlans);
  const accountMode = useAppSelector(profileSelectors.getProfileSlice).data
    ?.accountMode;
  const isAiTraceOnly = useAppSelector(userSelectors.checkIfAiTraceOnly);

  return useMemo(() => {
    if (!accountMode) return [];

    const category = getPlansAvailability(accountMode, isAiTraceOnly)
      .available[0];

    return category ? sortPlansByCategory(plans ?? [])[category] ?? [] : [];
  }, [plans, accountMode, isAiTraceOnly]);
};

export default useOwnPlans;
